export const isBetaEnvironment = () => {
  return window.location.host.indexOf(process.env.BETA_ENV_HOST) === 0;
};
